;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"ac20225a4cba33420c1466b5d2141ef93e3663e6"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from '@sentry/nextjs';
import getConfig from 'next/config';
const { publicRuntimeConfig } = getConfig();

Sentry.init({
  environment: publicRuntimeConfig.stage,
  dsn: publicRuntimeConfig.sentryDsnFe,
  tracesSampleRate: 1.0,
});
